import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { DiscountEditPage, discountQueryOptions } from '@/features/discounts';

export const Route = createFileRoute('/_authed/_active/s/$storeId/discounts/$discountId')({
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'discounts.read');
  },
  loader: async ({ context, params }) => {
    const discount = await context.queryClient.query({
      ...discountQueryOptions(params.storeId, params.discountId),
      staleTime: 'static',
    });
    return { crumb: discount.title };
  },
  component: DiscountEditPage,
});
